import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import urls from '../../constants/urls.js';
import ArtistService from '../../services/artistService.js';
import trimStart from 'lodash/trimStart';
import * as imageUtils from '../../utils/imageUtils';

class ConnectionItem extends Component {
    constructor(props, context) {
        super(props, context);
        this.connectDisconnect = this.connectDisconnect.bind(this);
        this.setRef = this.setRef.bind(this);
    }    

    componentDidMount() {
        $(this.tooltipButtonRef).tooltip();
    }

    connectDisconnect(event) {
        this.props.connectDisconnect(event, { RoleID: this.props.connection.ID, Name: this.props.connection.DisplayName });
    }

    setRef(tooltipButtonRef) {
        this.tooltipButtonRef = tooltipButtonRef;
    }

    getThumbnail(imageUrl, roleType) {
        const params = '?width=42&aspectw=1&quality=80&mode=crop&scale=both';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    }

    render() {        
        let {connection, actions, artist, inbound, index, user, isPluggedIn, getPlugInText, getPlugInTooltip} = this.props;
        return (
            <tr className="transition">
                <td style={{paddingLeft:'4px'}}>
                    <div className="imgbox">
                        <Link to={`/${connection.Username}`}>
                            <img src={this.getThumbnail(connection.ImageUrl, connection.RoleType)} alt={connection.DisplayName} />
                        </Link>
                    </div>
                </td>
                <td>
                    <h2>
                        <Link to={`/${connection.Username}`} className="transition">{connection.DisplayName}</Link>
                    </h2>
                    <p className="small">{ArtistService.getRoleTypeFriendlyName(connection.RoleType)}</p>
                </td>
                <td className="tbl-right">
                    <button className={`btn btn-primary btn-plug btn-plug-small transition btn-50 tip ${isPluggedIn(connection.ID) ? 'btn-active': '' }`} data-toggle="tooltip" data-placement={index == 0 ? 'bottom' : 'top'} title={getPlugInTooltip(connection.ID)} onClick={this.connectDisconnect} ref={this.setRef}>
                        <svg className="icon icn-plug">
                            <use xlinkHref="#icn-plug" />
                        </svg>
                        <span id="buttonText">{getPlugInText(connection.ID)}</span>
                    </button>
                </td>
            </tr>    
        );
    }
}

ConnectionItem.propTypes = {
    connection: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    artist: PropTypes.object.isRequired,
    inbound: PropTypes.bool,
    index: PropTypes.number.isRequired,
    user: PropTypes.object,
    isPluggedIn: PropTypes.func.isRequired,
    getPlugInText: PropTypes.func.isRequired,
    getPlugInTooltip: PropTypes.func.isRequired,
    connectDisconnect: PropTypes.func.isRequired
};

export default ConnectionItem;